var map = {
	"./033-bm.webp": 1337,
	"./033-cn.webp": 1338,
	"./033.webp": 1339,
	"./13-bm.webp": 1340,
	"./13-cn.webp": 1341,
	"./13.webp": 1342,
	"./3-bm.webp": 1343,
	"./3-cn.webp": 1344,
	"./3.webp": 1345,
	"./angpao-bg-mobile.jpg": 1346,
	"./angpao-bg.jpg": 1347,
	"./angpao-bm.webp": 1348,
	"./angpao-cn.webp": 1349,
	"./angpao.webp": 1350,
	"./button.png": 1351,
	"./close-eye.png": 1352,
	"./coin-1.png": 1353,
	"./coin.png": 1354,
	"./ketupak-open.png": 1355,
	"./ketupak.png": 1356,
	"./ketupak_ribbon.png": 1357,
	"./rain-1.png": 1358,
	"./rain-2.png": 1359,
	"./rain-3.png": 1360,
	"./raya-bg-mobile.png": 1361,
	"./raya-bg.png": 1362,
	"./shine.png": 1363,
	"./star-1.png": 1364,
	"./star-2.png": 1365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 451;